import { useTheme } from '@emotion/react';
import { colors } from '@revenuemarket/design';
export function useDefaultProps() {
  const theme = useTheme();

  return {
    border: true,
    borderColor: `${colors.grayscaleWhite}0D`,
    textColor: colors.grayscale600,
    backgroundColor: colors.grayscale50,
  };
}
